// extracted by mini-css-extract-plugin
module.exports = {"btn":"_1VCPaxyHU3wKHZ4UE9zMj"};